module.exports = __webpack_public_path__ + "img/hof_4.6f5d3961.jpg";